
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import config from "@/config/config";
import gateway from "@/lib/request/gateway";
import PostPolicy from "@/lib/model/gateway/post-policy";
import _ from "lodash";
import Auth from "@/lib/common/auth";

@Component({})
export default class UploadImg extends Vue {
  @Prop({ default: "examLogoUrl", type: String }) private imgType!: string;
  @Prop({ default: "", type: String }) private img!: string;
  @Prop({ default: "750 x 1624px", type: String }) private text!: string;
  loading = false;
  headers = {};
  imageUrl = "";
  postPolicy: PostPolicy = new PostPolicy();
  defaultBG =
    "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png";

  get uploadUrl() {
    return _.trim(config.accountUrl) + "/api/common/uploadOss";
  }
  get token() {
    return Auth.token;
  }

  @Watch("img", { immediate: true })
  onImgChange(val: string) {
    this.imageUrl = val === this.defaultBG ? "" : val; //默认图片不在上传处展示
  }
  mounted() {
    // this.imageUrl = this.img;
  }

  afterUpload(e: any) {
    this.loading = false;
    if (e.code === 0) {
      this.imageUrl = e.data.url;
    }
  }
  uploadImg(data: { filename: string; file: File }) {
    const { filename, file } = data;
    console.log(filename);
    this.loading = true;
    const isJPG =
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG) {
      this.$message.error("上传图片只能是 JPG/JPEG/PNG 格式!");
      this.loading = false;
      return false;
    }
    if (!isLt2M) {
      this.$message.error("上传图片过大!");
      this.loading = false;
      return false;
    }
    // 上传图片到oss
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
        gateway
          .upload(postRes, file)
          .then((res: any) => {
            console.log("upload res : ", res);
          })
          .finally(() => {
            this.imageUrl = tempUrl;
            this.$emit("change", this.imageUrl);
          });
      }
    });
  }

  uploadSuccess(e: any) {
    this.loading = false;
    if (e.code === 0) {
      this.imageUrl = e.data.url;
      this.$message.success("上传成功");
    }
  }
  delImg() {
    this.$emit("change", "");
  }
  error() {
    console.log("error");
  }
  downloadImg() {
    this.openImageInNewTab();
  }

  openImageInNewTab() {
    if (!this.imageUrl) return;

    fetch(this.imageUrl)
      .then(response => response.blob())
      .then(blob => {
        const objectUrl = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = "image_" + new Date().getTime() + ".jpg"; // Set filename with timestamp

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(objectUrl);
      })
      .catch(error => {
        console.error("Download failed:", error);
        window.location.href = this.imageUrl;
      });
  }
}
